import React from 'react';
import { useTheme } from 'styled-components';
import Spacer from 'components/Spacer';
import { Heading } from 'components/Typography';
import { getShorthandActionColor } from 'utils/styled';
import * as S from './styles';
import { ToastProps } from './types';

const Toast: React.FC<ToastProps> = ({
  actionLabel,
  className,
  accentColor = 'primary',
  icon,
  heading,
  onAction,
  subHeading,
}) => {
  const theme = useTheme();

  const iconInfo = {
    width: '30px',
    height: '30px',
    color: getShorthandActionColor(accentColor)({ theme }),
  };

  return (
    <S.Root className={className} $accentColor={accentColor}>
      <div>
        {icon &&
          React.cloneElement(icon, {
            ...iconInfo,
          })}
      </div>
      <Spacer orientation="vertical" space={0}>
        <Heading level={2}>{heading}</Heading>
        <S.Subheading>{subHeading}</S.Subheading>
      </Spacer>
      {actionLabel && (
        <S.ActionContainer>
          <S.ActionButton $color={accentColor} onPress={onAction}>
            {actionLabel}
          </S.ActionButton>
        </S.ActionContainer>
      )}
    </S.Root>
  );
};

export default Toast;
